import { render, staticRenderFns } from "./icon-tel.vue?vue&type=template&id=e8c923e8&scoped=true&"
import script from "./icon-tel.vue?vue&type=script&lang=js&"
export * from "./icon-tel.vue?vue&type=script&lang=js&"
import style0 from "./icon-tel.vue?vue&type=style&index=0&id=e8c923e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c923e8",
  null
  
)

export default component.exports